import { useState, useContext, useEffect } from 'react';
import { IonContent, IonPage, IonSelect, IonSelectOption } from '@ionic/react';
import Navbar from '../../components/Navbar';
import { PDFViewer, PDFDownloadLink } from '@react-pdf/renderer';
import { Page, Text, View, Document, StyleSheet } from '@react-pdf/renderer';
import { useIonViewDidEnter } from '@ionic/react';
import { ServerUrl, GetCurrentYear } from '../../constants';
import { AppContext } from "../../context/appContext";
import axios from 'axios';

const styles = StyleSheet.create({
    page: {
        flexDirection: 'row',
        backgroundColor: '#E4E4E4'
    },
    section: {
        margin: 10,
        padding: 10,
        flexGrow: 1,
        border: '1px solid black'
    },
    viewer: {
        width: window.innerWidth, //the pdf viewer will take up all of the width and height
        height: window.innerHeight,
    },
});

const Home: React.FC = () => {
    const { CurrentUser } = useContext(AppContext);
    const token = CurrentUser ? CurrentUser.token : null;

    const [monthly_CurrentTotal, SetMonthlyCurrentTotal] = useState<Array<any>>([]);
    const [monthly_CurrentBoard, SetMonthlyCurrentBoard] = useState<Array<any>>([]);

    const [monthly_PreviousTotal, SetMonthlyPreviousTotal] = useState<Array<any>>([]);
    const [monthly_PreviousBoard, SeMonthlytPreviousBoard] = useState<Array<any>>([]);


    const [monthly_CurrentData, SetMonthlyCurrentData] = useState<Array<any>>([]);
    const [monthly_PreviousData, SetMonthlyPreviousData] = useState<Array<any>>([]);

    const [currentRegion, setCurrentRegion] = useState<string>("Region 1");
    const [pdfName, setPdfName] = useState("")

    const currentYear = GetCurrentYear() - 2000;
    let current_year = currentYear + '-' + (currentYear + 1);
    let previous_year = (currentYear - 1) + '-' + currentYear;

    const currentFullYear = GetCurrentYear();
    let current_full_year = currentFullYear + ' - ' + (currentFullYear + 1);
    let previous_full_year = (currentFullYear - 1) + ' - ' + currentFullYear;

    useIonViewDidEnter(() => {
        if (currentRegion == 'All') {
            download();
        }
        else {
            monthly_LoadData();
            LoadData_22A();
            LoadData_22B();
            LoadData_25();
            LoadData_26();
            setPdfName(currentRegion + "_quarterly_" + current_year + ".pdf");
        }

    });

    useEffect(() => {
        if (currentRegion == 'All') {
            download();
        }
        else {
            monthly_LoadData();
            LoadData_22A();
            LoadData_22B();
            LoadData_25();
            LoadData_26();
            setPdfName(currentRegion + "_quarterly_" + current_year + ".pdf");
        }
    }, [currentRegion]);

    const monthly_totalUrl = `${ServerUrl}/monthly/2.1a/total/region`;
    const monthly_boardUrl = `${ServerUrl}/monthly/2.1a/board/region`;
    const monthly_dataUrl = `${ServerUrl}/monthly/2.1/region`;
    const allUrl = `${ServerUrl}/quaterly/all`;
    const download = async () => {
        const response = await fetch(`${allUrl}?current=${current_year}&previous=${previous_year + ""}`,
            {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            }
        );
        const blob = await response.blob();

        // Create a URL for the blob object
        const url = URL.createObjectURL(blob);

        // Create a link element and simulate a click to download the file
        const link = document.createElement('a');
        link.href = url;
        link.download = 'Quaterly.zip';
        link.click();

        // Revoke the URL once the download is complete
        setTimeout(() => URL.revokeObjectURL(url), 60000);
    }
    const monthly_LoadData = () => {
        axios.get(`${monthly_totalUrl}?year=${current_year}&region=${currentRegion + " ESC"}`, {
            headers: {
                'Authorization': "Bearer " + token,
            }
        }).then(res => {
            if (res.data && res.data.length > 0) {
                SetMonthlyCurrentTotal(res.data);
            }
        }, err => {
            alert("Fail to get data. " + JSON.stringify(err))
        });

        axios.get(`${monthly_totalUrl}?year=${previous_year}&region=${currentRegion + " ESC"}`, {
            headers: {
                'Authorization': "Bearer " + token,
            }
        }).then(res => {
            if (res.data && res.data.length > 0) {
                SetMonthlyPreviousTotal(res.data);
            }
        }, err => {
            console.log("Fail to get data. " + JSON.stringify(err))
        });

        axios.get(`${monthly_boardUrl}?year=${current_year}&region=${currentRegion + " ESC"}`, {
            headers: {
                'Authorization': "Bearer " + token,
            }
        }).then(res => {
            if (res.data && res.data.length > 0) {
                SetMonthlyCurrentBoard(res.data);
            }
        }, err => {
            alert("Fail to get data. " + JSON.stringify(err))
        });

        axios.get(`${monthly_boardUrl}?year=${previous_year}&region=${currentRegion + " ESC"}`, {
            headers: {
                'Authorization': "Bearer " + token,
            }
        }).then(res => {
            if (res.data && res.data.length > 0) {
                SeMonthlytPreviousBoard(res.data);
            }
        }, err => {
            console.log("Fail to get data. " + JSON.stringify(err))
        });

        axios.get(`${monthly_dataUrl}?year=${current_year}&region=${currentRegion + " ESC"}`, {
            headers: {
                'Authorization': "Bearer " + token,
            }
        }).then(res => {
            if (res.data && res.data.length > 0) {
                SetMonthlyCurrentData(res.data);
            }
        }, err => {
            alert("Fail to get data. " + JSON.stringify(err))
        });

        axios.get(`${monthly_dataUrl}?year=${previous_year}&region=${currentRegion + " ESC"}`, {
            headers: {
                'Authorization': "Bearer " + token,
            }
        }).then(res => {
            if (res.data && res.data.length > 0) {
                SetMonthlyPreviousData(res.data);
            }
        }, err => {
            console.log("Fail to get data. " + JSON.stringify(err))
        });

    };

    const getSum_Monthly = (data: Array<any>, year: string): string => {
        let sum = 0;
        data.filter(element => element.year === year).forEach(item => sum += parseFloat(item.trainContactHours));
        return sum === 0 ? "0" : sum.toFixed(0);
    }

    const getData_Monthly = (dataArray: Array<any>, name: string) => {
        let num = 0;

        let element = dataArray.find(e => e.month === name);
        if (element) {
            num = parseFloat(element.trainContactHours);
        }
        return num;
    }

    const RenderRow_Monthly = (name: string, data1: string, data2: string) => {
        return (
            <View style={{ height: '20px', display: 'flex', flexDirection: 'row' }}>
                <View style={{ flex: 1, borderRight: '1px solid black', borderBottom: '1px solid black', display: 'flex', justifyContent: 'center', alignItems: 'flex-start' }}>
                    <Text>{name}</Text>
                </View>
                <View style={{ flex: 1, borderRight: '1px solid black', borderBottom: '1px solid black', height: '100%', justifyContent: 'center', alignItems: 'center' }}>
                    <Text>{parseInt(data1).toLocaleString()}</Text>
                </View>
                <View style={{ flex: 1, height: '100%', justifyContent: 'center', alignItems: 'center', borderBottom: '1px solid black', }}>
                    <Text>{parseInt(data2).toLocaleString()}</Text>
                </View>
            </View>
        );
    }

    const dataUrl_22A = `${ServerUrl}/quaterly/2.2a/region`;

    const [CurrentData_22A, SetCurrentData_22A] = useState<Array<any>>([]);
    const [PreviousData_22A, SetPreviousData_22A] = useState<Array<any>>([]);

    const [CurrentContactSum_22A, SetCurrentContactSum_22A] = useState<string>('0');
    const [CurrentDeliveredSum_22A, SetCurrentDeliveredSum_22A] = useState<string>('0');

    const [PreviousContactSum_22A, SetPreviousContactSum_22A] = useState<string>('0');
    const [PreviousDeliveredSum_22A, SetPreviousDeliveredSum_22A] = useState<string>('0');

    const LoadData_22A = () => {
        SetCurrentData_22A([]);
        SetCurrentContactSum_22A("");
        SetCurrentDeliveredSum_22A("");
        SetPreviousData_22A([]);
        SetPreviousContactSum_22A("");
        SetPreviousDeliveredSum_22A("");

        axios.get(`${dataUrl_22A}?year=${current_year}&region=${currentRegion + " ESC"}`, {
            headers: {
                'Authorization': "Bearer " + token,
            }
        }).then(res => {
            if (res.data && res.data.length > 0) {
                SetCurrentData_22A(res.data);
                console.log(res.data);
                SetCurrentContactSum_22A(getSum_22A(res.data, true));
                SetCurrentDeliveredSum_22A(getSum_22A(res.data, false));
            }
        }, err => {
            alert("Fail to get data. " + JSON.stringify(err))
        });

        axios.get(`${dataUrl_22A}?year=${previous_year}&region=${currentRegion + " ESC"}`, {
            headers: {
                'Authorization': "Bearer " + token,
            }
        }).then(res => {
            if (res.data && res.data.length > 0) {
                SetPreviousData_22A(res.data);
                SetPreviousContactSum_22A(getSum_22A(res.data, true));
                SetPreviousDeliveredSum_22A(getSum_22A(res.data, false));
            }
        }, err => {
            console.log("Fail to get data. " + JSON.stringify(err))
        });
    };

    const getQuaterData_22A = (dataArray: Array<any>, name: string, first: boolean) => {
        let num = 0;
        let element = dataArray.find(e => e.quater === name);
        if (element) {
            if (first) {
                var data = parseFloat(element.contacts);
                if (!isNaN(data)) {
                    num = data;
                }
            }
            else {
                var data2 = parseFloat(element.contactHoursDelivered)
                if (!isNaN(data2)) {
                    num = data2;
                }
            }
        }
        return num;
    }

    const getSum_22A = (data: Array<any>, forContacts: boolean): string => {
        let sum = 0;
        if (forContacts) {
            data.forEach(item => {
                var data = parseFloat(item.contacts)
                if (!isNaN(data)) {
                    sum += data;
                }
            });
        }
        else {
            data.forEach(item => {
                var data2 = parseFloat(item.contactHoursDelivered)
                if (!isNaN(data2)) {
                    sum += data2;
                }
            });
        }
        return sum === 0 ? sum.toString() : sum.toFixed(0);
    }

    const GetTimeZone = () => {
        var offset = new Date().getTimezoneOffset();
        if (offset === 480) return "PST";
        else if (offset === 420) return "MST";
        else if (offset === 360) return "MST";
        else if (offset === 300) return "CST";
        else if (offset === 240) return "EST";
        return "";
    }

    const RenderRow_22A = (name: string, data1: string, data2: string, data3: string, data4: string) => {
        return (
            <View style={{ height: '20px', display: 'flex', flexDirection: 'row' }}>
                <View style={{ flex: 3, borderRight: '1px solid black', borderBottom: '1px solid black', display: 'flex', justifyContent: 'center', alignItems: 'flex-start' }}>
                    <Text>{name}</Text>
                </View>
                <View style={{ flex: 2, borderRight: '1px solid black', borderBottom: '1px solid black', height: '100%', justifyContent: 'center', alignItems: 'center' }}>
                    <Text>{data1 == '' ? '' : parseFloat(data1).toLocaleString()}</Text>
                </View>
                <View style={{ flex: 2, height: '100%', justifyContent: 'center', alignItems: 'center', borderRight: '1px solid black', borderBottom: '1px solid black', }}>
                    <Text>{data2 == '' ? '' : parseFloat(data2).toLocaleString()}</Text>
                </View>
                <View style={{ flex: 2, borderRight: '1px solid black', borderBottom: '1px solid black', height: '100%', justifyContent: 'center', alignItems: 'center' }}>
                    <Text>{data3 == '' ? '' : parseFloat(data3).toLocaleString()}</Text>
                </View>
                <View style={{ flex: 2, height: '100%', justifyContent: 'center', alignItems: 'center', borderBottom: '1px solid black', }}>
                    <Text>{data4 == '' ? '' : parseFloat(data4).toLocaleString()}</Text>
                </View>
            </View>
        );
    }


    const [CurrentData_22B, SetCurrentData_22B] = useState<Array<any>>([]);
    const [PreviousData_22B, SetPreviousData_22B] = useState<Array<any>>([]);

    const [CurrentContactSum_22B, SetCurrentContactSum_22B] = useState<string>('0');
    const [CurrentDeliveredSum_22B, SetCurrentDeliveredSum_22B] = useState<string>('0');

    const [PreviousContactSum_22B, SetPreviousContactSum_22B] = useState<string>('0');
    const [PreviousDeliveredSum_22B, SetPreviousDeliveredSum_22B] = useState<string>('0');

    const LoadData_22B = () => {
        const dataUrl = `${ServerUrl}/quaterly/2.2b/region`;
        axios.get(`${dataUrl}?year=${current_year}&region=${currentRegion + " ESC"}`, {
            headers: {
                'Authorization': "Bearer " + token,
            }
        }).then(res => {
            if (res.data && res.data.length > 0) {
                SetCurrentData_22B(res.data);
                SetCurrentContactSum_22B(getSum_22B(res.data, true));
                SetCurrentDeliveredSum_22B(getSum_22B(res.data, false));
            }
        }, err => {
            alert("Fail to get data. " + JSON.stringify(err))
        });

        axios.get(`${dataUrl}?year=${previous_year}&region=${currentRegion + " ESC"}`, {
            headers: {
                'Authorization': "Bearer " + token,
            }
        }).then(res => {
            if (res.data && res.data.length > 0) {
                SetPreviousData_22B(res.data);
                SetPreviousContactSum_22B(getSum_22B(res.data, true));
                SetPreviousDeliveredSum_22B(getSum_22B(res.data, false));
            }
        }, err => {
            console.log("Fail to get data. " + JSON.stringify(err))
        });
    };

    const getSum_22B = (data: Array<any>, forContacts: boolean): string => {
        let sum = 0;
        if (forContacts) {
            data.forEach(item => {
                var data = parseFloat(item.contacts)
                if (!isNaN(data)) {
                    sum += data;
                }
            });
        }
        else {
            data.forEach(item => {
                var data2 = parseFloat(item.contactHoursDelivered)
                if (!isNaN(data2)) {
                    sum += data2;
                }
            });
        }
        return sum === 0 ? sum.toString() : sum.toFixed(2);
    }

    const [CurrentData_25, SetCurrentData_25] = useState<Array<any>>([]);
    const [PreviousData_25, SetPreviousData_25] = useState<Array<any>>([]);

    const [CurrentParticipantSum_25, SetCurrentParticipantSum_25] = useState<string>('0');
    const [CurrentEventSum_25, SetCurrentEventSum_25] = useState<string>('0');

    const [PreviousParticipantSum_25, SetPreviousParticipantSum_25] = useState<string>('0');
    const [PreviousEventSum_25, SetPreviousEventSum_25] = useState<string>('0');

    const LoadData_25 = () => {
        const dataUrl = `${ServerUrl}/quaterly/2.5/region`;
        axios.get(`${dataUrl}?year=${current_year}&region=${currentRegion + " ESC"}`, {
            headers: {
                'Authorization': "Bearer " + token,
            }
        }).then(res => {
            if (res.data && res.data.length > 0) {
                SetCurrentData_25(res.data);
                SetCurrentParticipantSum_25(getSum_25(res.data, true));
                SetCurrentEventSum_25(getSum_25(res.data, false));
            }
        }, err => {
            alert("Fail to get data. " + JSON.stringify(err))
        });

        axios.get(`${dataUrl}?year=${previous_year}&region=${currentRegion + " ESC"}`, {
            headers: {
                'Authorization': "Bearer " + token,
            }
        }).then(res => {
            if (res.data && res.data.length > 0) {
                SetPreviousData_25(res.data);
                SetPreviousParticipantSum_25(getSum_25(res.data, true));
                SetPreviousEventSum_25(getSum_25(res.data, false));
            }
        }, err => {
            console.log("Fail to get data. " + JSON.stringify(err))
        });
    };

    const getQuaterData_25 = (dataArray: Array<any>, name: string, first: boolean) => {
        let num = 0;
        let element = dataArray.find(e => e.quater === name);
        if (element) {
            if (first) {
                let data = parseFloat(element.participants);
                if (!isNaN(data)) {
                    num = data;
                }
            }
            else {
                let data = parseFloat(element.events)
                if (!isNaN(data)) {
                    num = data;
                }
            }
        }
        return num;
    }

    const getSum_25 = (data: Array<any>, forContacts: boolean): string => {
        let sum = 0;
        if (forContacts) {
            data.forEach(item => {
                let data = parseFloat(item.participants)
                if (!isNaN(data)) {
                    sum += data;
                }
            });
        }
        else {
            data.forEach(item => {
                let data = parseFloat(item.events)
                if (!isNaN(data)) {
                    sum += data;
                }
            });
        }
        return sum.toFixed(0);
    }

    const [CurrentData_26, SetCurrentData_26] = useState<Array<any>>([]);
    const [PreviousData_26, SetPreviousData_26] = useState<Array<any>>([]);

    const [CurrentParticipantsSum_26, SetCurrentParticipantsSum_26] = useState<string>('0');
    const [CurrentEventsSum_26, SetCurrentEventsSum_26] = useState<string>('0');

    const [PreviousParticipantsSum_26, SetPreviousParticipantsSum_26] = useState<string>('0');
    const [PreviousEventsSum_26, SetPreviousEventsSum_26] = useState<string>('0');

    const LoadData_26 = () => {
        const dataUrl = `${ServerUrl}/semiannually/2.6/region`;
        axios.get(`${dataUrl}?year=${current_year}&region=${currentRegion + " ESC"}`, {
            headers: {
                'Authorization': "Bearer " + token,
            }
        }).then(res => {
            if (res.data && res.data.length > 0) {
                SetCurrentData_26(res.data);
                SetCurrentParticipantsSum_26(getSum_26(res.data, "Participants"));
                SetCurrentEventsSum_26(getSum_26(res.data, "Events"));
            }
        }, err => {
            console.log("Fail to get data. " + JSON.stringify(err))
        });

        axios.get(`${dataUrl}?year=${previous_year}&region=${currentRegion + " ESC"}`, {
            headers: {
                'Authorization': "Bearer " + token,
            }
        }).then(res => {
            if (res.data && res.data.length > 0) {
                SetPreviousData_26(res.data);
                SetPreviousParticipantsSum_26(getSum_26(res.data, "Participants"));
                SetPreviousEventsSum_26(getSum_26(res.data, "Events"));
            }
        }, err => {
            console.log("Fail to get data. " + JSON.stringify(err))
        });
    };

    const getData_26 = (dataArray: Array<any>, quater: string, name: string) => {
        let num = 0;
        let element = dataArray.find(e => e.quater === quater);
        if (element) {
            if (name === "Participants") {
                num = parseFloat(element.participants);
            }
            else if (name === "Events") {
                num = parseFloat(element.events)
            }
        }
        return num;
    }

    const getSum_26 = (data: Array<any>, name: string): string => {
        let sum = 0;
        if (name === "Participants") {
            data.forEach(item => {
                let data = parseFloat(item.participants)
                if (!isNaN(data)) {
                    sum += data;
                }
            });
        }
        else if (name === "Events") {
            data.forEach(item => {
                let data = parseFloat(item.events)
                if (!isNaN(data)) {
                    sum += data;
                }
            });
        }
        return sum === 0 ? sum.toString() : sum.toFixed(0);
    }


    const RenderPDF_Monthly = () => {
        return (
            <>
                <Document>
                    <Page size="A4" style={{ flexDirection: 'column', padding: '20px', fontSize: '12px' }}>
                        <div style={{ width: '90%', marginLeft: '5%' }}>
                            <View style={{ display: 'flex', flexDirection: 'column', marginBottom: '10px', padding: '10px' }}>
                                <View style={{ justifyContent: 'center', alignItems: 'center', marginBottom: '4px', fontSize: '14px', fontWeight: 'bold' }}>
                                    <Text>Quarterly Scorecard Report</Text>
                                </View>
                                <View style={{ justifyContent: 'center', alignItems: 'center', fontSize: '14px', fontWeight: 'bold' }}>
                                    <Text>{currentRegion} Education Service Center</Text>
                                </View>
                            </View>

                            <View style={{ fontSize: '12px', marginBottom: '10px', fontWeight: 'bold' }}>
                                <Text>Indicator 2.1</Text>
                                <Text>Number of Individuals Trained</Text>
                            </View>

                            <div style={{ borderRight: '1px solid black', borderTop: '1px solid black', borderLeft: '1px solid black', }}>
                                <View style={{ height: '40px', display: 'flex', flexDirection: 'row', fontWeight: 'bold', backgroundColor: 'lightgray' }}>
                                    <View style={{
                                        flex: 1, justifyContent: 'flex-end', alignItems: 'flex-start',
                                        borderRight: '1px solid black', borderBottom: '1px solid black'
                                    }}>
                                        <Text>Month</Text>
                                    </View>
                                    <View style={{ flex: 1, borderRight: '1px solid black', borderBottom: '1px solid black', justifyContent: 'flex-end', alignItems: 'center' }}>
                                        <Text>Total Individuals Trained</Text>
                                        <Text>{current_full_year}</Text>
                                    </View>
                                    <View style={{ flex: 1, justifyContent: 'flex-end', alignItems: 'center', borderBottom: '1px solid black' }}>
                                        <Text>Total Individuals Trained</Text>
                                        <Text>{previous_full_year}</Text>
                                    </View>
                                </View>

                                {RenderRow_Monthly("September", getData_Monthly(monthly_CurrentTotal, 'September').toString(), getData_Monthly(monthly_PreviousTotal, 'September').toString())}
                                {RenderRow_Monthly("October", getData_Monthly(monthly_CurrentTotal, 'October').toString(), getData_Monthly(monthly_PreviousTotal, 'October').toString())}
                                {RenderRow_Monthly("November", getData_Monthly(monthly_CurrentTotal, 'November').toString(), getData_Monthly(monthly_PreviousTotal, 'November').toString())}
                                {RenderRow_Monthly("December", getData_Monthly(monthly_CurrentTotal, 'December').toString(), getData_Monthly(monthly_PreviousTotal, 'December').toString())}
                                {RenderRow_Monthly("January", getData_Monthly(monthly_CurrentTotal, 'January').toString(), getData_Monthly(monthly_PreviousTotal, 'January').toString())}
                                {RenderRow_Monthly("February", getData_Monthly(monthly_CurrentTotal, 'February').toString(), getData_Monthly(monthly_PreviousTotal, 'February').toString())}
                                {RenderRow_Monthly("March", getData_Monthly(monthly_CurrentTotal, 'March').toString(), getData_Monthly(monthly_PreviousTotal, 'March').toString())}
                                {RenderRow_Monthly("April", getData_Monthly(monthly_CurrentTotal, 'April').toString(), getData_Monthly(monthly_PreviousTotal, 'April').toString())}
                                {RenderRow_Monthly("May", getData_Monthly(monthly_CurrentTotal, 'May').toString(), getData_Monthly(monthly_PreviousTotal, 'May').toString())}
                                {RenderRow_Monthly("June", getData_Monthly(monthly_CurrentTotal, 'June').toString(), getData_Monthly(monthly_PreviousTotal, 'June').toString())}
                                {RenderRow_Monthly("July", getData_Monthly(monthly_CurrentTotal, 'July').toString(), getData_Monthly(monthly_PreviousTotal, 'July').toString())}
                                {RenderRow_Monthly("August", getData_Monthly(monthly_CurrentTotal, 'August').toString(), getData_Monthly(monthly_PreviousTotal, 'August').toString())}
                                {RenderRow_Monthly("Total", getSum_Monthly(monthly_CurrentTotal, current_year), getSum_Monthly(monthly_PreviousTotal, previous_year))}
                            </div>

                            <div style={{ borderRight: '1px solid black', borderTop: '1px solid black', borderLeft: '1px solid black', marginTop: '20px' }}>
                                <View style={{ height: '40px', display: 'flex', flexDirection: 'row', fontWeight: 'bold', backgroundColor: 'lightgray' }}>
                                    <View style={{
                                        flex: 1, height: '40px', justifyContent: 'flex-end', alignItems: 'flex-start',
                                        borderRight: '1px solid black', borderBottom: '1px solid black'
                                    }}>
                                        <Text>Month</Text>
                                    </View>

                                    <View style={{ flex: 1, borderRight: '1px solid black', borderBottom: '1px solid black', height: '100%', justifyContent: 'flex-end', alignItems: 'center' }}>
                                        <Text>Board Members Trained</Text>
                                        <Text>{current_full_year}</Text>
                                    </View>
                                    <View style={{ flex: 1, height: '100%', justifyContent: 'flex-end', alignItems: 'center', borderBottom: '1px solid black' }}>
                                        <Text>Board Members Trained</Text>
                                        <Text>{previous_full_year}</Text>
                                    </View>
                                </View>

                                {RenderRow_Monthly("September", getData_Monthly(monthly_CurrentBoard, 'September').toString(), getData_Monthly(monthly_PreviousBoard, 'September').toString())}
                                {RenderRow_Monthly("October", getData_Monthly(monthly_CurrentBoard, 'October').toString(), getData_Monthly(monthly_PreviousBoard, 'October').toString())}
                                {RenderRow_Monthly("November", getData_Monthly(monthly_CurrentBoard, 'November').toString(), getData_Monthly(monthly_PreviousBoard, 'November').toString())}
                                {RenderRow_Monthly("December", getData_Monthly(monthly_CurrentBoard, 'December').toString(), getData_Monthly(monthly_PreviousBoard, 'December').toString())}
                                {RenderRow_Monthly("January", getData_Monthly(monthly_CurrentBoard, 'January').toString(), getData_Monthly(monthly_PreviousBoard, 'January').toString())}
                                {RenderRow_Monthly("February", getData_Monthly(monthly_CurrentBoard, 'February').toString(), getData_Monthly(monthly_PreviousBoard, 'February').toString())}
                                {RenderRow_Monthly("March", getData_Monthly(monthly_CurrentBoard, 'March').toString(), getData_Monthly(monthly_PreviousBoard, 'March').toString())}
                                {RenderRow_Monthly("April", getData_Monthly(monthly_CurrentBoard, 'April').toString(), getData_Monthly(monthly_PreviousBoard, 'April').toString())}
                                {RenderRow_Monthly("May", getData_Monthly(monthly_CurrentBoard, 'May').toString(), getData_Monthly(monthly_PreviousBoard, 'May').toString())}
                                {RenderRow_Monthly("June", getData_Monthly(monthly_CurrentBoard, 'June').toString(), getData_Monthly(monthly_PreviousBoard, 'June').toString())}
                                {RenderRow_Monthly("July", getData_Monthly(monthly_CurrentBoard, 'July').toString(), getData_Monthly(monthly_PreviousBoard, 'July').toString())}
                                {RenderRow_Monthly("August", getData_Monthly(monthly_CurrentBoard, 'August').toString(), getData_Monthly(monthly_PreviousBoard, 'August').toString())}
                                {RenderRow_Monthly("Total", getSum_Monthly(monthly_CurrentBoard, current_year), getSum_Monthly(monthly_PreviousBoard, previous_year))}
                            </div>

                            <View style={{ height: '30px', display: 'flex', flexDirection: 'row', marginTop: '30px', justifyContent: 'space-between' }}>
                                <View>
                                    <Text></Text>
                                </View>
                                <View>
                                    <Text>{new Date().toLocaleString()} {GetTimeZone()}</Text>
                                </View>
                            </View>
                        </div>
                    </Page>

                    <Page size="A4" style={{ flexDirection: 'column', padding: '20px', fontSize: '12px' }}>
                        <div style={{ width: '90%', marginLeft: '5%' }}>
                            <View style={{ fontSize: '12px', marginBottom: '10px', fontWeight: 'bold', marginTop: '0px' }}>
                                <Text>Indicator 2.1a</Text>
                                <Text>Training Contact Hours Delivered</Text>
                            </View>

                            <div style={{ borderRight: '1px solid black', borderTop: '1px solid black', borderLeft: '1px solid black', marginTop: '10px' }}>
                                <View style={{ height: '40px', display: 'flex', flexDirection: 'row', fontWeight: 'bold', backgroundColor: 'lightgray' }}>
                                    <View style={{
                                        flex: 1, height: '40px', justifyContent: 'flex-end', alignItems: 'flex-start',
                                        borderRight: '1px solid black', borderBottom: '1px solid black'
                                    }}>
                                        <Text>Month</Text>
                                    </View>
                                    <View style={{ flex: 1, borderRight: '1px solid black', borderBottom: '1px solid black', height: '100%', justifyContent: 'flex-end', alignItems: 'center' }}>
                                        <Text>Training Contact Hours</Text>
                                        <Text>{current_full_year}</Text>
                                    </View>
                                    <View style={{ flex: 1, height: '100%', justifyContent: 'flex-end', alignItems: 'center', borderBottom: '1px solid black' }}>
                                        <Text>Training Contact Hours</Text>
                                        <Text>{previous_full_year}</Text>
                                    </View>
                                </View>

                                {RenderRow_Monthly("September", getData_Monthly(monthly_CurrentData, 'September').toString(), getData_Monthly(monthly_PreviousData, 'September').toString())}
                                {RenderRow_Monthly("October", getData_Monthly(monthly_CurrentData, 'October').toString(), getData_Monthly(monthly_PreviousData, 'October').toString())}
                                {RenderRow_Monthly("November", getData_Monthly(monthly_CurrentData, 'November').toString(), getData_Monthly(monthly_PreviousData, 'November').toString())}
                                {RenderRow_Monthly("December", getData_Monthly(monthly_CurrentData, 'December').toString(), getData_Monthly(monthly_PreviousData, 'December').toString())}
                                {RenderRow_Monthly("January", getData_Monthly(monthly_CurrentData, 'January').toString(), getData_Monthly(monthly_PreviousData, 'January').toString())}
                                {RenderRow_Monthly("February", getData_Monthly(monthly_CurrentData, 'February').toString(), getData_Monthly(monthly_PreviousData, 'February').toString())}
                                {RenderRow_Monthly("March", getData_Monthly(monthly_CurrentData, 'March').toString(), getData_Monthly(monthly_PreviousData, 'March').toString())}
                                {RenderRow_Monthly("April", getData_Monthly(monthly_CurrentData, 'April').toString(), getData_Monthly(monthly_PreviousData, 'April').toString())}
                                {RenderRow_Monthly("May", getData_Monthly(monthly_CurrentData, 'May').toString(), getData_Monthly(monthly_PreviousData, 'May').toString())}
                                {RenderRow_Monthly("June", getData_Monthly(monthly_CurrentData, 'June').toString(), getData_Monthly(monthly_PreviousData, 'June').toString())}
                                {RenderRow_Monthly("July", getData_Monthly(monthly_CurrentData, 'July').toString(), getData_Monthly(monthly_PreviousData, 'July').toString())}
                                {RenderRow_Monthly("August", getData_Monthly(monthly_CurrentData, 'August').toString(), getData_Monthly(monthly_PreviousData, 'August').toString())}
                                {RenderRow_Monthly("Total", getSum_Monthly(monthly_CurrentData, current_year), getSum_Monthly(monthly_PreviousData, previous_year))}
                            </div>

                            <View style={{ fontSize: '12px', marginBottom: '10px', fontWeight: 'bold', marginTop: '10px' }}>
                                <Text>Indicator 2.2a</Text>
                                <Text>Technical Assistance Contacts and Technical Assistance of a Quarter Hour or Greater</Text>
                            </View>

                            <div style={{ borderRight: '1px solid black', borderTop: '1px solid black', borderLeft: '1px solid black', marginTop: '0px' }}>
                                <View style={{ height: '40px', display: 'flex', flexDirection: 'row', fontWeight: 'bold', backgroundColor: 'lightgray' }}>
                                    <View style={{
                                        flex: 3, height: '40px', justifyContent: 'flex-end', alignItems: 'flex-start',
                                        borderRight: '1px solid black', borderBottom: '1px solid black'
                                    }}>
                                        <Text>Reporting Period</Text>
                                    </View>
                                    <View style={{ flex: 2, borderRight: '1px solid black', borderBottom: '1px solid black', height: '100%', justifyContent: 'flex-end', alignItems: 'center' }}>
                                        <Text>Contacts</Text>
                                        <Text>{current_full_year}</Text>
                                    </View>
                                    <View style={{ flex: 2, height: '100%', justifyContent: 'flex-end', alignItems: 'center', borderBottom: '1px solid black', borderRight: '1px solid black' }}>
                                        <Text>Contact Hours</Text>
                                        <Text>{current_full_year}</Text>
                                    </View>
                                    <View style={{ flex: 2, borderRight: '1px solid black', borderBottom: '1px solid black', height: '100%', justifyContent: 'flex-end', alignItems: 'center' }}>
                                        <Text>Contacts</Text>
                                        <Text>{previous_full_year}</Text>
                                    </View>
                                    <View style={{ flex: 2, height: '100%', justifyContent: 'flex-end', alignItems: 'center', borderBottom: '1px solid black' }}>
                                        <Text>Contact Hours</Text>
                                        <Text>{previous_full_year}</Text>
                                    </View>
                                </View>

                                {RenderRow_22A("September - November",
                                    getQuaterData_22A(CurrentData_22A, "September - November", true).toString(),
                                    getQuaterData_22A(CurrentData_22A, "September - November", false).toString(),
                                    getQuaterData_22A(PreviousData_22A, "September - November", true).toString(),
                                    getQuaterData_22A(PreviousData_22A, "September - November", false).toString())}
                                {RenderRow_22A("December - February",
                                    getQuaterData_22A(CurrentData_22A, "December - February", true).toString(),
                                    getQuaterData_22A(CurrentData_22A, "December - February", false).toString(),
                                    getQuaterData_22A(PreviousData_22A, "December - February", true).toString(),
                                    getQuaterData_22A(PreviousData_22A, "December - February", false).toString())}
                                {RenderRow_22A("March - May",
                                    getQuaterData_22A(CurrentData_22A, "March - May", true).toString(),
                                    getQuaterData_22A(CurrentData_22A, "March - May", false).toString(),
                                    getQuaterData_22A(PreviousData_22A, "March - May", true).toString(),
                                    getQuaterData_22A(PreviousData_22A, "March - May", false).toString())}
                                {RenderRow_22A("June - August",
                                    getQuaterData_22A(CurrentData_22A, "June - August", true).toString(),
                                    getQuaterData_22A(CurrentData_22A, "June - August", false).toString(),
                                    getQuaterData_22A(PreviousData_22A, "June - August", true).toString(),
                                    getQuaterData_22A(PreviousData_22A, "June - August", false).toString())}
                                {RenderRow_22A("Total", CurrentContactSum_22A, CurrentDeliveredSum_22A, PreviousContactSum_22A, PreviousDeliveredSum_22A)}

                            </div>

                            <View style={{ fontSize: '12px', marginBottom: '10px', fontWeight: 'bold', marginTop: '10px' }}>
                                <Text>Indicator 2.2b</Text>
                                <Text>Natural Disaster and Emergency Mass Electronic Communications Technical Assistance Contacts and Technical Assistance of a Quarter Hour or Greater</Text>
                            </View>

                            <div style={{ borderRight: '1px solid black', borderTop: '1px solid black', borderLeft: '1px solid black', marginTop: '0px' }}>
                                <View style={{ height: '40px', display: 'flex', flexDirection: 'row', fontWeight: 'bold', backgroundColor: 'lightgray' }}>
                                    <View style={{
                                        flex: 3, height: '40px', justifyContent: 'flex-end', alignItems: 'flex-start',
                                        borderRight: '1px solid black', borderBottom: '1px solid black'
                                    }}>
                                        <Text>Reporting Period</Text>
                                    </View>
                                    <View style={{ flex: 2, borderRight: '1px solid black', borderBottom: '1px solid black', height: '100%', justifyContent: 'flex-end', alignItems: 'center' }}>
                                        <Text>Contacts</Text>
                                        <Text>{current_full_year}</Text>
                                    </View>
                                    <View style={{ flex: 2, height: '100%', justifyContent: 'flex-end', alignItems: 'center', borderBottom: '1px solid black', borderRight: '1px solid black' }}>
                                        <Text>Contact Hours</Text>
                                        <Text>{current_full_year}</Text>
                                    </View>
                                    <View style={{ flex: 2, borderRight: '1px solid black', borderBottom: '1px solid black', height: '100%', justifyContent: 'flex-end', alignItems: 'center' }}>
                                        <Text>Contacts</Text>
                                        <Text>{previous_full_year}</Text>
                                    </View>
                                    <View style={{ flex: 2, height: '100%', justifyContent: 'flex-end', alignItems: 'center', borderBottom: '1px solid black' }}>
                                        <Text>Contact Hours</Text>
                                        <Text>{previous_full_year}</Text>
                                    </View>
                                </View>

                                {RenderRow_22A("September - November",
                                    getQuaterData_22A(CurrentData_22B, "September - November", true).toString(),
                                    getQuaterData_22A(CurrentData_22B, "September - November", false).toString(),
                                    getQuaterData_22A(PreviousData_22B, "September - November", true).toString(),
                                    getQuaterData_22A(PreviousData_22B, "September - November", false).toString())}
                                {RenderRow_22A("December - February",
                                    getQuaterData_22A(CurrentData_22B, "December - February", true).toString(),
                                    getQuaterData_22A(CurrentData_22B, "December - February", false).toString(),
                                    getQuaterData_22A(PreviousData_22B, "December - February", true).toString(),
                                    getQuaterData_22A(PreviousData_22B, "December - February", false).toString())}
                                {RenderRow_22A("March - May",
                                    getQuaterData_22A(CurrentData_22B, "March - May", true).toString(),
                                    getQuaterData_22A(CurrentData_22B, "March - May", false).toString(),
                                    getQuaterData_22A(PreviousData_22B, "March - May", true).toString(),
                                    getQuaterData_22A(PreviousData_22B, "March - May", false).toString())}
                                {RenderRow_22A("June - August",
                                    getQuaterData_22A(CurrentData_22B, "June - August", true).toString(),
                                    getQuaterData_22A(CurrentData_22B, "June - August", false).toString(),
                                    getQuaterData_22A(PreviousData_22B, "June - August", true).toString(),
                                    getQuaterData_22A(PreviousData_22B, "June - August", false).toString())}
                                {RenderRow_22A("Total", CurrentContactSum_22B, CurrentDeliveredSum_22B, PreviousContactSum_22B, PreviousDeliveredSum_22B)}

                            </div>


                            <View style={{ height: '30px', display: 'flex', flexDirection: 'row', marginTop: '30px', justifyContent: 'space-between' }}>
                                <View>
                                    <Text></Text>
                                </View>
                                <View>
                                    <Text>{new Date().toLocaleString()} {GetTimeZone()}</Text>
                                </View>
                            </View>
                        </div>
                    </Page>

                    <Page size="A4" style={{ flexDirection: 'column', padding: '20px', fontSize: '12px' }}>
                        <div style={{ width: '90%', marginLeft: '5%' }}>
                            <View style={{ fontSize: '12px', marginBottom: '10px', fontWeight: 'bold', marginTop: '0px' }}>
                                <Text>Indicator 2.5</Text>
                                <Text>Number of Individuals Participating in Learning Through Online Learning and the Number of Online Learning Events</Text>
                            </View>

                            <div style={{ borderRight: '1px solid black', borderTop: '1px solid black', borderLeft: '1px solid black', marginTop: '10px' }}>
                                <View style={{ height: '40px', display: 'flex', flexDirection: 'row', fontWeight: 'bold', backgroundColor: 'lightgray' }}>
                                    <View style={{
                                        flex: 3, height: '40px', justifyContent: 'flex-end', alignItems: 'flex-start',
                                        borderRight: '1px solid black', borderBottom: '1px solid black'
                                    }}>
                                        <Text>Reporting Period</Text>
                                    </View>
                                    <View style={{ flex: 2, borderRight: '1px solid black', borderBottom: '1px solid black', height: '100%', justifyContent: 'flex-end', alignItems: 'center' }}>
                                        <Text>Participants</Text>
                                        <Text>{current_full_year}</Text>
                                    </View>
                                    <View style={{ flex: 2, borderRight: '1px solid black', borderBottom: '1px solid black', height: '100%', justifyContent: 'flex-end', alignItems: 'center' }}>
                                        <Text>Events</Text>
                                        <Text>{current_full_year}</Text>
                                    </View>
                                    <View style={{ flex: 2, height: '100%', justifyContent: 'flex-end', alignItems: 'center', borderBottom: '1px solid black', borderRight: '1px solid black' }}>
                                        <Text>Participants</Text>
                                        <Text>{previous_full_year}</Text>
                                    </View>
                                    
                                    <View style={{ flex: 2, height: '100%', justifyContent: 'flex-end', alignItems: 'center', borderBottom: '1px solid black' }}>
                                        <Text>Events</Text>
                                        <Text>{previous_full_year}</Text>
                                    </View>
                                </View>

                                {RenderRow_22A("September - November",
                                    getQuaterData_25(CurrentData_25, "September - November", true).toString(),
                                    getQuaterData_25(CurrentData_25, "September - November", false).toString(),
                                    getQuaterData_25(PreviousData_25, "September - November", true).toString(),                                    
                                    getQuaterData_25(PreviousData_25, "September - November", false).toString())}
                                {RenderRow_22A("December - February",
                                    getQuaterData_25(CurrentData_25, "December - February", true).toString(),
                                    getQuaterData_25(CurrentData_25, "December - February", false).toString(),
                                    getQuaterData_25(PreviousData_25, "December - February", true).toString(),                                    
                                    getQuaterData_25(PreviousData_25, "December - February", false).toString())}
                                {RenderRow_22A("March - May",
                                    getQuaterData_25(CurrentData_25, "March - May", true).toString(),
                                    getQuaterData_25(CurrentData_25, "March - May", false).toString(),
                                    getQuaterData_25(PreviousData_25, "March - May", true).toString(),                                    
                                    getQuaterData_25(PreviousData_25, "March - May", false).toString())}
                                {RenderRow_22A("June - August",
                                    getQuaterData_25(CurrentData_25, "June - August", true).toString(),
                                    getQuaterData_25(CurrentData_25, "June - August", false).toString(),
                                    getQuaterData_25(PreviousData_25, "June - August", true).toString(),                                    
                                    getQuaterData_25(PreviousData_25, "June - August", false).toString())}
                                {RenderRow_22A("Total", CurrentParticipantSum_25, CurrentEventSum_25, PreviousParticipantSum_25, PreviousEventSum_25)}

                            </div>

                            {/*<View style={{ fontSize: '12px', marginBottom: '10px', fontWeight: 'bold', marginTop: '10px' }}>*/}
                            {/*    <Text>Indicator 2.6</Text>*/}
                            {/*    <Text>Number of Students Participating in Learning Through Regional Distance Learning and the Number of Distance Learning Events</Text>*/}
                            {/*</View>*/}

                            {/*<div style={{ borderRight: '1px solid black', borderTop: '1px solid black', borderLeft: '1px solid black', marginTop: '10px' }}>*/}
                            {/*    <View style={{ height: '40px', display: 'flex', flexDirection: 'row', fontWeight: 'bold', backgroundColor: 'lightgray' }}>*/}
                            {/*        <View style={{*/}
                            {/*            flex: 3, height: '40px', justifyContent: 'flex-end', alignItems: 'flex-start',*/}
                            {/*            borderRight: '1px solid black', borderBottom: '1px solid black'*/}
                            {/*        }}>*/}
                            {/*            <Text>Reporting Period</Text>*/}
                            {/*        </View>*/}
                            {/*        <View style={{ flex: 2, borderRight: '1px solid black', borderBottom: '1px solid black', height: '100%', justifyContent: 'flex-end', alignItems: 'center' }}>*/}
                            {/*            <Text>Student</Text>*/}
                            {/*            <Text>Participants</Text>*/}
                            {/*            <Text>{current_full_year}</Text>*/}
                            {/*        </View>*/}
                            {/*        <View style={{ flex: 2, height: '100%', justifyContent: 'flex-end', alignItems: 'center', borderBottom: '1px solid black', borderRight: '1px solid black' }}>*/}
                            {/*            <Text>Events</Text>*/}
                            {/*            <Text>{current_full_year}</Text>*/}
                            {/*        </View>*/}
                            {/*        <View style={{ flex: 2, borderRight: '1px solid black', borderBottom: '1px solid black', height: '100%', justifyContent: 'flex-end', alignItems: 'center' }}>*/}
                            {/*            <Text>Student</Text>*/}
                            {/*            <Text>Participants</Text>*/}
                            {/*            <Text>{previous_full_year}</Text>*/}
                            {/*        </View>*/}
                            {/*        <View style={{ flex: 2, height: '100%', justifyContent: 'flex-end', alignItems: 'center', borderBottom: '1px solid black' }}>*/}
                            {/*            <Text>Events</Text>*/}
                            {/*            <Text>{previous_full_year}</Text>*/}
                            {/*        </View>*/}
                            {/*    </View>*/}

                            {/*    {RenderRow_22A("September - November",*/}
                            {/*        getData_26(CurrentData_26, "September - November", "Participants").toString(),*/}
                            {/*        getData_26(CurrentData_26, "September - November", "Events").toString(),*/}
                            {/*        getData_26(PreviousData_26, "September - November", "Participants").toString(),*/}
                            {/*        getData_26(PreviousData_26, "September - November", "Events").toString(),*/}
                            {/*    )}*/}
                            {/*    {RenderRow_22A("December - February",*/}
                            {/*        getQuaterData_25(CurrentData_26, "December - February", true).toString(),*/}
                            {/*        getQuaterData_25(CurrentData_26, "December - February", false).toString(),*/}
                            {/*        getQuaterData_25(PreviousData_26, "December - February", true).toString(),*/}
                            {/*        getQuaterData_25(PreviousData_26, "December - February", false).toString())}*/}
                            {/*    {RenderRow_22A("March - August",*/}
                            {/*        getQuaterData_25(CurrentData_26, "March - August", true).toString(),*/}
                            {/*        getQuaterData_25(CurrentData_26, "March - August", false).toString(),*/}
                            {/*        getQuaterData_25(PreviousData_26, "March - August", true).toString(),*/}
                            {/*        getQuaterData_25(PreviousData_26, "March - August", false).toString())}*/}
                            {/*    {RenderRow_22A("Total", CurrentParticipantsSum_26, CurrentEventsSum_26, PreviousParticipantsSum_26, PreviousEventsSum_26)}*/}

                            {/*</div>*/}


                            <View style={{ height: '30px', display: 'flex', flexDirection: 'row', marginTop: '300px', justifyContent: 'space-between' }}>
                                <View>
                                    <Text></Text>
                                </View>
                                <View>
                                    <Text>{new Date().toLocaleString()} {GetTimeZone()}</Text>
                                </View>
                            </View>
                        </div>
                    </Page>

                </Document>
            </>
        )
    };

    return (
        <IonPage>
            <Navbar />
            <IonContent fullscreen>
                <div style={{ padding: '10px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    Select a Region
                    <div style={{ padding: '0px 10px 0px 10px', border: '1px solid black', borderRadius: '4px', margin: '0px 10px' }}>
                        <IonSelect placeholder="Select a role" value={currentRegion} onIonChange={(e) => setCurrentRegion((e.target as HTMLInputElement).value)}>
                            <IonSelectOption value="Region 1">Region 1</IonSelectOption>
                            <IonSelectOption value="Region 2">Region 2</IonSelectOption>
                            <IonSelectOption value="Region 3">Region 3</IonSelectOption>
                            <IonSelectOption value="Region 4">Region 4</IonSelectOption>
                            <IonSelectOption value="Region 5">Region 5</IonSelectOption>
                            <IonSelectOption value="Region 6">Region 6</IonSelectOption>
                            <IonSelectOption value="Region 7">Region 7</IonSelectOption>
                            <IonSelectOption value="Region 8">Region 8</IonSelectOption>
                            <IonSelectOption value="Region 9">Region 9</IonSelectOption>
                            <IonSelectOption value="Region 10">Region 10</IonSelectOption>
                            <IonSelectOption value="Region 11">Region 11</IonSelectOption>
                            <IonSelectOption value="Region 12">Region 12</IonSelectOption>
                            <IonSelectOption value="Region 13">Region 13</IonSelectOption>
                            <IonSelectOption value="Region 14">Region 14</IonSelectOption>
                            <IonSelectOption value="Region 15">Region 15</IonSelectOption>
                            <IonSelectOption value="Region 16">Region 16</IonSelectOption>
                            <IonSelectOption value="Region 17">Region 17</IonSelectOption>
                            <IonSelectOption value="Region 18">Region 18</IonSelectOption>
                            <IonSelectOption value="Region 19">Region 19</IonSelectOption>
                            <IonSelectOption value="Region 20">Region 20</IonSelectOption>
                            <IonSelectOption value="All">All</IonSelectOption>
                        </IonSelect>
                    </div>

                    <PDFDownloadLink document={RenderPDF_Monthly()} fileName={pdfName}>
                        {({ blob, url, loading, error }) =>
                            loading ? 'Loading document...' : pdfName
                        }
                    </PDFDownloadLink>
                </div>

                <PDFViewer style={styles.viewer}>
                    {RenderPDF_Monthly()}
                </PDFViewer>

            </IonContent>
        </IonPage>
    );
};

export default Home;
